module.exports = __webpack_public_path__ + "img/uz.096d1175.jpg";